import { cva } from "class-variance-authority";

export const fieldTriggerButtonVariants = cva(
  [
    "border-shape-neutral-outlined-border-emphasised bg-shape-neutral-outlined-background text-shape-neutral-outlined-foreground-default data-[placeholder]:text-shape-neutral-outlined-foreground-muted focus-visible:ring-ring-default focus:ring-ring-default aria-invalid:border-shape-critical-outlined-border-emphasised flex w-full cursor-pointer items-center gap-2 self-stretch border px-3 py-2 text-left text-sm leading-normal font-normal transition-[color,box-shadow] outline-none focus:ring-[3px] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
  ],
  {
    variants: {
      variant: {
        default: "rounded-lg",
        pill: "rounded-full",
      },
    },
    defaultVariants: { variant: "default" },
  }
);
